// extracted by mini-css-extract-plugin
export default {"bot-loader":"BotLoader_bot-loader__nQ5Gd","profile-image":"BotLoader_profile-image__oJsuF","svg":"BotLoader_svg__s8wwv","loader":"BotLoader_loader__Q5muc"};